import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const govee = defineConnector({
  identifier: "govee",
  name: "Govee",
  tagLine: "Smart lighting and home devices",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://openapi\\.api\\.govee\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "Govee-API-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Request an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the Govee Home app, open the profile tab → Settings → Apply for API key. Govee emails the key to you.",
        },
      ],
    },
    {
      title: "Paste your Govee API key below",
      items: [
        {
          kind: "input",
          label: "Govee API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://openapi.api.govee.com/router/api/v1/user/devices",
  },
});
